/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainEntitiesAghanimPaymentStatus } from './FxIdDomainEntitiesAghanimPaymentStatus';
import {
    FxIdDomainEntitiesAghanimPaymentStatusFromJSON,
    FxIdDomainEntitiesAghanimPaymentStatusFromJSONTyped,
    FxIdDomainEntitiesAghanimPaymentStatusToJSON,
    FxIdDomainEntitiesAghanimPaymentStatusToJSONTyped,
} from './FxIdDomainEntitiesAghanimPaymentStatus';

/**
 * 
 * @export
 * @interface FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto
 */
export interface FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto
     */
    CheckoutUrl: string;
    /**
     * 
     * @type {FxIdDomainEntitiesAghanimPaymentStatus}
     * @memberof FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto
     */
    Status: FxIdDomainEntitiesAghanimPaymentStatus;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto
     */
    AghanimStatus?: string | null;
}



/**
 * Check if a given object implements the FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto interface.
 */
export function instanceOfFxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto(value: object): value is FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto {
    if (!('CheckoutUrl' in value) || value['CheckoutUrl'] === undefined) return false;
    if (!('Status' in value) || value['Status'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoFromJSON(json: any): FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto {
    return FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoFromJSONTyped(json, false);
}

export function FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'CheckoutUrl': json['CheckoutUrl'],
        'Status': FxIdDomainEntitiesAghanimPaymentStatusFromJSON(json['Status']),
        'AghanimStatus': json['AghanimStatus'] == null ? undefined : json['AghanimStatus'],
    };
}

export function FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoToJSON(json: any): FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto {
    return FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoToJSONTyped(json, false);
}

export function FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoToJSONTyped(value?: FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'CheckoutUrl': value['CheckoutUrl'],
        'Status': FxIdDomainEntitiesAghanimPaymentStatusToJSON(value['Status']),
        'AghanimStatus': value['AghanimStatus'],
    };
}

